module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search",
      "append-icon": "search",
      "rules": [_vm.rules.search],
      "hint": _vm.hints.search()
    },
    on: {
      "click:append": _vm.search,
      "click": _vm.search,
      "change": _vm.search
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.searchFor),
      callback: function($$v) {
        _vm.searchFor = $$v
      },
      expression: "searchFor"
    }
  })], 1), _vm._v(" "), (_vm.state == 'list') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.returnportals,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.uuid))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.customer.customerId))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.customer.customerName1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.customer.customerName2))]), _vm._v(" "), _c('td', [_c('router-link', {
          attrs: {
            "to": ("/returnshopportals/" + (item.uuid))
          }
        }, [_vm._v("Settings")])], 1)])]
      }
    }], null, false, 1270951800)
  }) : _vm._e(), _vm._v(" "), (_vm.state == 'search') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.returnportals,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.uuid))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.customer.customerId))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.customer.customerName1))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.customer.customerName2))]), _vm._v(" "), _c('td', [_c('router-link', {
          attrs: {
            "to": ("/returnshopportals/" + (item.uuid))
          }
        }, [_vm._v("Settings")])], 1)])]
      }
    }], null, false, 1270951800)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/returnshopportals/activate"
    }
  }, [_vm._v("New")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-acb28ee6"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/List.vue
// module id = 948
// module chunks = 1